/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_DismissInputs */



/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Toast_DismissInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const toast_dismiss = /** @type {((inputs?: Toast_DismissInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_DismissInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descartar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dispensar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi")
	return /** @type {LocalizedString} */ ("Dismiss")
});